// extracted by mini-css-extract-plugin
export default {"giftIcon":"Gf9yH","price":"yVP7r","giftName":"rqvVN","priceValue":"hFKbM","myMessage":"aN94n","info":"M6iHh"};